import { OverlayPositionBuilder, FlexibleConnectedPositionStrategy } from '@angular/cdk/overlay';
import { ElementRef, Injectable } from '@angular/core';

@Injectable()
export class SidenavMenuPositionStrategy extends FlexibleConnectedPositionStrategy {
  /**
   * Updates the position of the overlay element, using whichever preferred position relative
   * to the origin best fits on-screen.
   */
  apply(): void {
    if (
      this['_pane'] &&
      this['_pane'].firstChild &&
      this['_pane'].firstChild.classList &&
      this['_pane'].firstChild.classList.contains('sidebar-flyout-menu')
    ) {
      this['_offsetX'] = 64;
    }
    super.apply();
  }
}

@Injectable()
export class ExtendedPositionBuilder extends OverlayPositionBuilder {
  /**
   * Creates a FlexibleConnectedPosition strategy.
   */
  flexibleConnectedTo(elementRef: ElementRef): SidenavMenuPositionStrategy {
    return new SidenavMenuPositionStrategy(
      elementRef,
      this['_viewportRuler'],
      this['_document'],
      this['_platform'],
      this['_overlayContainer']
    );
  }
}
